export var PrimitiveTypeIds;
(function (PrimitiveTypeIds) {
    PrimitiveTypeIds[PrimitiveTypeIds["UInt8"] = 0] = "UInt8";
    PrimitiveTypeIds[PrimitiveTypeIds["UInt16"] = 1] = "UInt16";
    PrimitiveTypeIds[PrimitiveTypeIds["UInt32"] = 2] = "UInt32";
    PrimitiveTypeIds[PrimitiveTypeIds["Int8"] = 3] = "Int8";
    PrimitiveTypeIds[PrimitiveTypeIds["Int16"] = 4] = "Int16";
    PrimitiveTypeIds[PrimitiveTypeIds["Int32"] = 5] = "Int32";
    PrimitiveTypeIds[PrimitiveTypeIds["Float32"] = 6] = "Float32";
    PrimitiveTypeIds[PrimitiveTypeIds["String"] = 7] = "String";
    PrimitiveTypeIds[PrimitiveTypeIds["Boolean"] = 8] = "Boolean";
    PrimitiveTypeIds[PrimitiveTypeIds["Null"] = 9] = "Null";
    PrimitiveTypeIds[PrimitiveTypeIds["Undefined"] = 10] = "Undefined";
    PrimitiveTypeIds[PrimitiveTypeIds["NaN"] = 11] = "NaN";
    PrimitiveTypeIds[PrimitiveTypeIds["Infinity"] = 12] = "Infinity";
    PrimitiveTypeIds[PrimitiveTypeIds["NegativeInfinity"] = 13] = "NegativeInfinity";
    PrimitiveTypeIds[PrimitiveTypeIds["Object"] = 14] = "Object";
})(PrimitiveTypeIds || (PrimitiveTypeIds = {}));
//# sourceMappingURL=PrimitiveTypeIds.js.map